import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Formik, Field } from 'formik'
import { Button, Form, Toast } from 'lib/ui/components'
import { useCart, useCoupon } from 'lib/core/hooks'
import { FormContainer, CouponContainer } from './components/Styled'
import { schema } from './schema'

export const Coupon = () => {
  const intl = useIntl()
  const { cart, applyCoupon, removeCoupon } = useCart()
  const [coupon, setCoupon] = useState('')
  const appliedCoupon = cart?.data?.appliedCoupon

  const {
    isApplyCouponFetching,
    isRemoveCouponFetching
  } = useCoupon(coupon, {
    onApplySuccess: () => Toast.toastSuccess({ messageId: 'quote.couponCode.success' }),
    onApplyFailure: () => Toast.toastFailure({ messageId: 'quote.couponCode.failure' })
  })

  function handleSubmit (values: Record<string, string>) {
    const { code } = values
    setCoupon(code)
    applyCoupon({ code })
  }

  function handleRemoveCoupon () {
    setCoupon('')
    removeCoupon()
  }

  if (appliedCoupon) {
    return (
      <CouponContainer>
        <p>
          <FormattedMessage
            id='quote.couponCode.appliedCoupon'
          />
        </p>
        <p>
          <strong>{appliedCoupon}</strong>
        </p>
        <p>
          <Button
            skin={Button.SKIN.REGULAR}
            onClick={handleRemoveCoupon}
            isLoading={isRemoveCouponFetching}
          >
            <FormattedMessage
              id='quote.couponCode.action.remove'
            />
          </Button>
        </p>
      </CouponContainer>
    )
  } else {
    return (
      <FormContainer>
        <Formik
          initialValues={schema}
          onSubmit={handleSubmit}
        >
          {formik => { // TODO: migrate https://jaredpalmer.com/formik/docs/api/formik#formik-render-methods-and-props
            const { values } = formik
            const { code } = values

            return (
              <Form.Wrapper>
                <Field
                  name='code'
                  label={intl.formatMessage({
                    id: 'quote.couponCode.label.code'
                  })}
                  component={Form.Input}
                />

                <Button
                  type='submit'
                  skin={Button.SKIN.TEXT}
                  isLoading={isApplyCouponFetching}
                  isDisabled={!code}
                >
                  <FormattedMessage
                    id='quote.couponCode.action.apply'
                  />
                </Button>
              </Form.Wrapper>
            )
          }}
        </Formik>
      </FormContainer>
    )
  }
}
